import React from 'react';
import styled from 'styled-components';
import bg from '@assets/images/background/mode-battle.png';
import bgText from '@assets/images/background/mode-battle.svg';

type IProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  hidden?: boolean;
};

export default function ButtonBattle({ onClick, disabled, hidden }: IProps) {
  return (
    <Container
      $background={bg}
      disabled={disabled}
      hidden={hidden}
      onClick={onClick}
    >
      <img src={bgText} alt="" />
    </Container>
  );
}

const Container = styled.button<{
  disabled?: boolean;
  hidden?: boolean;
  $background?: string;
}>`
  cursor: pointer;
  border-radius: 16px 60px 16px 16px;
  border: 3px solid #fff;
  background-color: rgba(255, 255, 255, 0.8);
  background: ${({ $background }) =>
    $background ? `url('${$background}') center/cover no-repeat` : 'none'};
  opacity: ${({ disabled, hidden }) => {
    if (hidden) return 0;
    if (disabled) return 0.5;

    return 1;
  }};
  position: relative;
  overflow: hidden;
  pointer-events: ${({ disabled, hidden }) =>
    (disabled ?? hidden) ? 'none' : 'auto'};
  transition: all 0.6s linear;
  height: 100%;
  width: 100%;

  img {
    position: absolute;
    object-fit: contain;
    left: 0;
    bottom: 0;
    height: auto;
    width: 70%;
    transition: all 0.5s linear;

    @media screen and (orientation: portrait) {
      width: 50%;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }

  &:focus {
    img {
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 450px) {
    @media screen and (orientation: portrait) {
      border-radius: 16px 16px 16px 16px;
    }
  }
  @media screen and (max-height: 450px) {
    @media screen and (orientation: portrait) {
      border-radius: 16px 16px 16px 16px;
    }
  }
`;
